import { render, staticRenderFns } from "./Gli.vue?vue&type=template&id=616b8086&scoped=true"
import script from "./Gli.vue?vue&type=script&lang=js"
export * from "./Gli.vue?vue&type=script&lang=js"
import style0 from "./Gli.vue?vue&type=style&index=0&id=616b8086&prod&lang=css"
import style1 from "./Gli.vue?vue&type=style&index=1&id=616b8086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b8086",
  null
  
)

export default component.exports